export const AppColor = {
  "Background/Light Grey": "#F6F9FC",

  "Text/Dark Grey": "#767676",

  "Text/Black": "#000000",
  "Background/Dark Grey": "#E0E0E0",

  "Other/Success": "#4CAF4F",
  //
  "Background/Disable": "#C5C5C5",
  "Background/Background": "#EAEAEA",
  "Other Light/Warning": "#F8E6A4",
  "Other/Info": "#0084FF",
  "Other/Danger": "#FE7015",
  "Text/White": "#FFFFFF",
  "Text/Secondary": "#333333",
  "Text/Primary": "#000000",
  "Text/Line": "#7C7C7C",
  "Primary/Primary Text": "#16A34A",
  "Primary/Line": "#4ADE80",
  "Primary/Hover": "#4ADE80",
  "White / White": "#FFFFFF",
  "Primary/Primary": "#16A34A",
  "Secondary/Hover": "#4ADE80",
  "Secondary  Light/Background": "#FFE4E5",
};
